import { useContext, useState } from "react";
import "./money.css";
import VND from "../../../components/VND";
import Lang from "../../../components/Lang";
import { LanguageContext } from "../../../../../Context";
import AddButton from "../../../components/AddButton";
import DialogHT from "../../../components/DialogHT";
import CostTypeChooser from "../../../components/CostTypeChooser";
import { usePrimaryColor } from "../../../components/PrimaryColorContext";


/**
 * Costs list component.
 * Displays a list of cost records with totals and add button.
 * Uses flat premium design language with Tailwind utilities.
 *
 * @param {Object} props - Component props
 * @param {number} props.costType - Cost type (0 = cash, 1 = internet)
 * @param {Object} props.date - Current date filter
 * @param {Object} props.costs - Costs data object
 * @returns {JSX.Element} Costs section with list, total, and add dialog
 * @author Forge
 * @date 2026-04-08
 * @version 2.0
 */
export default function Costs({ costType, date, costs}) {
  
    const [open,setOpen]=useState(false)
   
    let dt = String(date)
  
    return (
      <div className="money-outline" style={{ border: 'none', boxShadow: 'none', padding: 0 }}>
        <div className="money-subtitle">
          <div>
            <Lang w="costs" />
          </div>
          <AddButton
            action={() => setOpen(true)}
            tooltip={<Lang w="addANewCost" />}
          />
        </div>
        {costs.map((c) => (
          <DrawCost
            cost={c}
            key={c._id}
          />
        ))}
        <div className="flex justify-between items-center mt-3 pt-3 border-t-2 border-slate-200">
          <div className="text-[0.8rem] font-extrabold text-slate-700 uppercase tracking-tight">
            <Lang w="total" />
          </div>
          <div className="text-[0.85rem] font-extrabold" >
            <VND value={costs.reduce("amount")} />
          </div>
        </div>
      
        <DialogHT
          open={open}
          setOpen={setOpen}
          title={"addANewCost"}
          content={content}
          success={(data) => costs.add(data)}
          url="/costs"
          extraData={{ paymentMethod: costType, tDate: dt}}
          http="put"
        />
      </div>
    );
}

/**
 * Single cost row component.
 * Displays cost description and amount.
 *
 * @param {Object} props - Component props
 * @param {Object} props.cost - Cost record
 * @returns {JSX.Element} Cost row
 * @author Forge
 * @date 2026-04-08
 * @version 2.0
 */
function DrawCost({ cost }) {
     const { language } = useContext(LanguageContext);
  const { primaryColor } = usePrimaryColor();
    return (
      <div className="money-cost">
        <div>{language===0 && cost.description_e ? cost.description_e : cost.description}</div>
        <div className="font-bold text-slate-700"><VND value={cost.amount} /></div>
      </div>
    )
}   

const content = [
  { label: "location", name: "location", type: "location", all: true },
  { label: "typeOfCost", name: "category", component: CostTypeChooser},
  { label: "whoOrderedThisCost?", name: "orderedBy", type: "staff" },
  { label: "description", name: "description", type: "text", multiline: true, rows: 3 },
  { label: "amount",name:"amount",type:"vnd"},
]